import React from 'react'
import { NextModal as Modal, Text } from '@components/UI'

const InvalidTypeModal = ({ close, files }) => {
  return (
    <Modal title='Invalid file type' close={close}>
      <div>
        <Text>
          We were not able to upload following file(s) as GoPeer does not
          support these types of files:
        </Text>
        <ul>
          {files.map((v) => (
            <li key={v.name}>{v.name}</li>
          ))}
        </ul>
      </div>
    </Modal>
  )
}

export default InvalidTypeModal
